/**
 * Atom – StatusBadge
 * Renders a "pending" or "reviewed" pill matching the project design system.
 */
import React from 'react';
import { MdHourglassEmpty, MdCheckCircle } from 'react-icons/md';

const STATUS_CONFIG = {
  pending: {
    label: 'Pending',
    icon: MdHourglassEmpty,
    classes: 'bg-status-warning-bg text-status-warning border border-status-warning/30'
  },
  reviewed: {
    label: 'Reviewed',
    icon: MdCheckCircle,
    classes: 'bg-status-success-bg text-status-success border border-status-success/30'
  }
};

const StatusBadge = ({ status }) => {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.pending;
  const Icon = config.icon;

  return (
    <span
      className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold uppercase tracking-wide ${config.classes}`}
    >
      <Icon size={12} />
      {config.label}
    </span>
  );
};

export default StatusBadge;
